// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"e2556554","856":"7774df9e","952":"9a132cbd"}[chunkId] + ".chunk.js";
};